import TeamLMSApp from "./containers/TeamLMSApp";

function App() {
  return (
    <TeamLMSApp />
  );
}

export default App;
